/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './createInviteCode.defs'
export { main as default } from './createInviteCode.defs'
